export const HOME = "/"
export const SUPPORT = "/support"
